var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:_vm.readyAction? 'ready-action' : ''},[_c('div',{staticClass:"fl"},[_c('quick-menu')],1),_c('div',{staticClass:"fr"},[_c('out-link')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }